function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M155.3,316.4c-13.8-23.9-26.9-46.5-40.9-70.8c88.5-51.8,146.2-128.6,180.4-226.3 c49.1,85,97.1,168.2,146.3,253.4C340,254.7,245.1,264.6,155.3,316.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M124,346.1c18.2-11.7,35.1-22.5,53-34c5.2,8.8,10,16.7,14.5,24.6c20.3,35.1,40.6,70.2,60.8,105.4 c8.8,15.3,7.7,18.5-7.7,27.6c-8,4.7-16.2,9.2-24.2,14c-8.5,5.1-14.9,3.4-19.9-5.1C175.4,435.1,150.3,391.6,124,346.1z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.7,249.5c13.5,23.3,27,46.6,40.8,70.5c-11.9,8.7-23,17.2-34.6,25c-3.2,2.1-8,2.6-12,2.7 c-18.4,0.3-30.7-9.8-39.5-24.8c-8.9-15-11.3-30.8-2-46.4c2.7-4.5,7.4-8.4,12.1-10.9C83.6,259.7,95.3,255,107.7,249.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M394.3,176.4c-13.4-23.2-26.2-45.3-39-67.4c17.7-8,37.3-1.7,47.8,14.7C414,140.4,410.9,161.4,394.3,176.4z"
});

var SvgGestionDePromociones = function SvgGestionDePromociones(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGestionDePromociones, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gestion_de_promociones.f4a4d3f2.svg";
export { ForwardRef as ReactComponent };